import { StyledCheckBox, StyledSheetDiv } from '../../../../shared/styles/components/integrations.styles';
import { StyledTd, StyledTh } from '../../../../shared/styles/components/table.styles';
import { Table, TableBody, TableHead } from '@mui/material';

import { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import styled from '@emotion/styled';
import { theme } from '../../../../shared/styles/core/theme';
import { thousandSeparator } from '../../../../shared/utils/formatters.utils';
import { tokens } from '../../../../shared/styles/core/tokens';

const sharedFlexItemStyles = `
   flex: 1;
   min-width: 24em;
`;

export const StyledEditDWPWeightContainer = styled.div`
   ${sharedFlexItemStyles}
   border-left: ${tokens.border.thin} ${theme.colors.border.default};
   padding-left: ${tokens.space.xl};
`;

export const StyledDWPWeightHeader = styled.p`
   margin-bottom: ${tokens.space.lg};
   color: ${theme.colors.text.primary};
   font-size: ${tokens.font.size.md};
`;

interface Supplier {
    buCodeSup: string;
    included: boolean;
    totalPartWeight?: number;
}

interface DWPWeightSectionProps {
    suppliers: Supplier[];
    control: Control<any>;
}

export const DWPWeightSection = ({ suppliers, control }: DWPWeightSectionProps) => {
    return (
        <StyledEditDWPWeightContainer>
            <StyledDWPWeightHeader><b>DWP weights for part</b></StyledDWPWeightHeader>
            <Table>
                <TableHead>
                    <tr>
                        <StyledTh>Included</StyledTh>
                        <StyledTh>Supplier</StyledTh>
                        <StyledTh>Total part weight (g)</StyledTh>
                    </tr>
                </TableHead>
                <TableBody>
                    {suppliers.map((supplier) => (
                        <tr key={supplier.buCodeSup}>
                            <StyledTd>
                                <Controller
                                    control={control}
                                    name={supplier.buCodeSup}
                                    render={({ field: { onChange, onBlur } }) => (
                                        <StyledSheetDiv style={{ justifyContent: 'space-between', display: 'flex' }}>
                                            <StyledCheckBox
                                                onBlur={onBlur}
                                                onChange={(e) => {
                                                    supplier.included = e.target.checked;
                                                    onChange(e);
                                                }}
                                                id={supplier.buCodeSup}
                                                value={supplier.buCodeSup}
                                                label={supplier.buCodeSup}
                                                checked={supplier.included}
                                            />
                                        </StyledSheetDiv>
                                    )}
                                />
                            </StyledTd>
                            <StyledTd>{supplier.buCodeSup}</StyledTd>
                            <StyledTd>
                                {supplier.totalPartWeight && thousandSeparator(Math.round(supplier.totalPartWeight))}
                            </StyledTd>
                        </tr>
                    ))}
                </TableBody>
            </Table>
        </StyledEditDWPWeightContainer>
    );
};
